export default async (goveoStoreRepository, id) => {
    const reference = await goveoStoreRepository.get(id);
    return {id: reference.id, ...reference.data()};
}
